import React, { PureComponent } from "react";
import cx from "classnames";
// BUG: Error on uglify when build project. Remove dependencie temporary
// import { login as loginSchema } from "@maxmilhas/max-validator";
import { sendRecoveryPasswordLink } from "../shared/requests-api";

/**
 * Wrapper that inclide input and label for email input
 */
const EmailInput = React.forwardRef(({ children, className, errorMessage, ...rest }, ref) => (
	<div className={className} data-tooltip={errorMessage} data-flow="down">
		<label htmlFor="recover_email">
			Preencha o campo abaixo e receba as instruções no seu e-mail cadastrado
		</label>
		<input
			ref={ref}
			aria-label="Digite seu e-mail"
			aria-required="true"
			className="form-control no-shadow no-bold"
			id="recover_email"
			name="recover_email"
			placeholder="E-mail"
			type="email"
			required
			{...rest}
		/>
		<i className="icon-user form-control-feedback" />
	</div>
));

const Header = ({ children, ...rest }) => (
	<div {...rest}>
		<h3 className="lead">{children}</h3>
	</div>
);
const Footer = () => (
	<>
		<p>
			Ainda não tem uma conta?{" "}
			<a href="/cadastro" className="a-link">
				Cadastre-se!
			</a>
		</p>
		<p>
			Já possui conta?{" "}
			<a href="/login" className="a-link">
				Faça login!
			</a>
		</p>
	</>
);

const SuccessAlert = () => (
	<div className="alert alert-success validate-success-msg">
		<div className="alert--icon">
			<i className="icon-check" />
		</div>
		<div className="alert--message">
			E-mail enviado com sucesso!
			<p>
				Agora verifique seu e-mail com as instruções para criar uma nova senha e então{" "}
				<a href="/login" className="a-link">
					faça o login
				</a>
				.
			</p>
		</div>
	</div>
);

class RecoverPassword extends PureComponent {
	static displayName = "RecoverPassword";

	state = {
		isSending: false,
		emailSent: false,
		errorMessage: undefined
	};

	constructor(...args) {
		super(...args);
		this.emailInputRef = React.createRef();
	}

	handleSubmit = async event => {
		event.preventDefault();

		try {
			await this.validate();
			const email = this.emailInputRef.current.value;
			this.setState({ isSending: true, errorMessage: undefined, emailSent: false });
			// const emailValid = await loginSchema.validateAt("email", { email });
			await sendRecoveryPasswordLink(email);
			this.setState({ isSending: false, emailSent: true });
		} catch (error) {
			const { name } = error;
			let errorMessage;
			if (error.response && error.response.status === 404) {
				errorMessage =
					"Este e-mail não existe cadastrado em nossa base. Insira um e-mail diferente.";
			} else if (name === "ValidationError") {
				const [firstError] = error.errors;
				errorMessage = firstError;
			} else if (error.message) {
				errorMessage = error.message;
			} else {
				errorMessage = "Erro ao tentar enviar e-mail de recuperação";
			}
			this.setState({ isSending: false, errorMessage });
		}
	};

	async validate() {
		const validEmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		const email = this.emailInputRef.current.value;
		return new Promise((resolve, reject) => {
			if (!email) {
				reject(Error("E-mail é obrigatório"));
			}
			if (!validEmailRegex.test(email)) {
				reject(Error("Não é um e-mail válido"));
			}

			resolve(email);
		});
	}

	handleInputChange = () => {
		this.setState({ errorMessage: undefined });
	};

	render() {
		const { isSending, emailSent, errorMessage } = this.state;
		const formGroupClasses = cx("form-group", {
			"has-error": !!errorMessage
		});

		return (
			<div className="recoverpage">
				<section className="container-fluid">
					<Header className="general-info">Recuperar senha</Header>
					<div className="wrapper-white">
						<div className="col-xs-16 col-md-8 col-md-offset-4">
							<section className="box-border box-recover">
								<form className="form-recover" onSubmit={this.handleSubmit} noValidate>
									<h4>Alterar a sua senha é fácil!</h4>
									{emailSent && <SuccessAlert />}
									<EmailInput
										onChange={this.handleInputChange}
										className={formGroupClasses}
										errorMessage={errorMessage}
										ref={this.emailInputRef}
										disabled={isSending}
									/>
									<button
										type="submit"
										name="button"
										className="btn btn-success"
										disabled={isSending}
									>
										<i className="icon-arrow-right" />Enviar
									</button>
									<Footer />
								</form>
							</section>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default RecoverPassword;
